export enum QUERY_KEY {
  PRODUCT_Q = "pq",
  LINK_Q = "lq"
}
